<template>
  <sec-section>
    <!-- Banner in the Services pricing style (SecPanel quiet), across the full page width. -->
    <sec-panel quiet class="home-who">
      <sec-section-heading :eyebrow="who.eyebrow" :title="who.title" />
      <p class="m500 sec-body-lg home-who__intro" data-reveal>{{ who.intro }}</p>

      <ul class="home-who__industries">
        <li v-for="item in who.items" :key="item.lead" class="home-who__industry" data-reveal>
          <h3 class="o600 sec-h3 home-who__name">{{ item.lead }}</h3>
          <p class="m500 sec-body home-who__need">{{ item.text.trim() }}</p>
        </li>
      </ul>

      <p class="m500 sec-body-lg home-who__also" data-reveal>{{ who.also }}</p>

      <div class="home-who__foot">
        <sec-actions :actions="who.actions" />
      </div>
    </sec-panel>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecPanel from '@/components/security/ui/SecPanel.vue';
import SecActions from '@/components/security/ui/SecActions.vue';
import { HOME } from '@/content/security/home';

const who = HOME.whoWeWorkWith;
</script>

<style scoped>
.sec-panel.home-who {
  gap: var(--sec-s4);
  text-align: center;
}

.home-who__intro,
.home-who__also {
  max-width: 820px;
  margin-inline: auto;
}

.home-who__industries {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(320px, 100%), 1fr));
  gap: var(--sec-s3);
  text-align: left;
}

.home-who__industry {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.25rem 1.5rem;
  background: var(--sec-surface);
  border: 1px solid var(--sec-line);
  border-left: 4px solid var(--sec-accent);
  border-radius: var(--sec-radius-card);
}

.home-who__name {
  margin: 0;
}

.home-who__need {
  max-width: none;
  color: var(--sec-ink-2);
}

.home-who__foot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sec-s3);
  padding-top: var(--sec-s4);
  border-top: 1px solid var(--sec-line-strong);
}

.home-who__foot :deep(.sec-actions) {
  justify-content: center;
}

@media only screen and (min-width: 700px) {
  .sec-panel.home-who {
    padding: 3.5rem;
  }
  .home-who__industry {
    padding: 1.75rem 2rem;
  }
}
</style>
